import React from "react";
import {createBrowserRouter, createRoutesFromElements, Route} from "react-router-dom";
import App from "../App";
import PrivateRoute from "./PrivateRoute";
import MainLayout from "../layouts/main";
import HomeScreen from "../pages/dashboard/home";
import VehicleScreen from "../pages/dashboard/vehicle";
import AuthLayout from "../layouts/auth";
import LoginScreen from "../pages/auth/login";
import Drivers from "../pages/dashboard/drivers";
import Settings from "../pages/dashboard/settings";
import VehicleDetail from "../pages/dashboard/vehicle/updateVehicle";
import UpdateDriver from "../pages/dashboard/drivers/updateDriver";
import Live from "../pages/dashboard/live";
import LiveDetail from "../pages/dashboard/live/LiveDetail/LiveDetail";
import CanBusSummary from "../pages/dashboard/reports/CanBusSummary";
import CanBus from "../pages/dashboard/reports/Canbus";
import IdleFuelReport from "../pages/dashboard/reports/IdleFuelReport";
import AlarmReport from "../pages/dashboard/reports/AlarmReport";
import ContactReport from "../pages/dashboard/reports/ContactReport";
import ResetPassword from "../pages/auth/reset-password";
import NewPassword from "../pages/auth/new-password";
import ManagerReport from "../pages/dashboard/reports/ManagerReport";
import CanBusDashboard from "../pages/dashboard/canbusdashboard";
import Groups from "../pages/dashboard/groups";
import GroupUpdate from "../pages/dashboard/groups/update";
import Support from "../pages/dashboard/support";

export const routes = createBrowserRouter(
    createRoutesFromElements(
        <Route path="/" element={<App/>}>
            <Route
                element={<MainLayout/>}
            >
                <Route path="" element={<PrivateRoute/>}>
                    <Route
                        index={true}
                        path="/"
                        auth={true}
                        element={<HomeScreen/>}
                    />
                    <Route
                        index={true}
                        path="/settings/vehicles"
                        auth={true}
                        element={<VehicleScreen/>}
                    />
                    <Route
                        index={true}
                        path="/settings/vehicles/:id"
                        auth={true}
                        element={<VehicleDetail/>}
                    />
                    <Route
                        index={true}
                        path="/live"
                        auth={true}
                        element={<Live/>}
                    />
                    <Route
                        index={true}
                        path="/live/:id"
                        auth={true}
                        element={<LiveDetail/>}
                    />
                    <Route
                        index={true}
                        path="/live/:id/:activeTab"
                        auth={true}
                        element={<LiveDetail/>}
                    />
                    <Route
                        index={true}
                        path="/settings/drivers"
                        auth={true}
                        element={<Drivers/>}
                    />
                    <Route
                        index={true}
                        path="/settings/drivers/:id"
                        auth={true}
                        element={<UpdateDriver/>}
                    />
                    <Route
                        index={true}
                        path="/settings/groups"
                        auth={true}
                        element={<Groups/>}
                    />
                    <Route
                        index={true}
                        path="/settings/groups/:id"
                        auth={true}
                        element={<GroupUpdate/>}
                    />
                    <Route
                        index={true}
                        path="/settings"
                        auth={true}
                        element={<Settings/>}
                    />
                    <Route
                        index={true}
                        path="/reports/canbus-summary"
                        auth={true}
                        element={<CanBusSummary/>}
                    />
                    <Route
                        index={true}
                        path="/reports/canbus"
                        auth={true}
                        element={<CanBus/>}
                    />
                    <Route
                        index={true}
                        path="/reports/contact"
                        auth={true}
                        element={<ContactReport/>}
                    />
                    <Route
                        index={true}
                        path="/reports/alarm"
                        auth={true}
                        element={<AlarmReport/>}
                    />
                    <Route
                        index={true}
                        path="/reports/idle-fuel"
                        auth={true}
                        element={<IdleFuelReport/>}
                    />
                    <Route
                        index={true}
                        path="/reports/manager-report"
                        auth={true}
                        element={<ManagerReport/>}
                    />
                    <Route
                        index={true}
                        path="/canbus-dashboard"
                        auth={true}
                        element={<CanBusDashboard/>}
                    />
                    <Route
                        index={true}
                        path="/support"
                        auth={true}
                        element={<Support/>}
                    />
                </Route>
            </Route>
            <Route
                path="/auth"
                element={<AuthLayout/>}
            >
                <Route
                    path="sign-in"
                    element={<LoginScreen/>}
                />
                <Route
                    path="reset-password"
                    element={<ResetPassword/>}
                />
                <Route
                    path="new-password/:token"
                    element={<NewPassword/>}
                />
            </Route>
        </Route>
    )
);
